export default function calcMarginPlannerBar(value1, value2) {
    return value1 + value2 - 100 - 1
}